import script from "./BecomeTutorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BecomeTutorPage.vue?vue&type=script&setup=true&lang=js"

import "./BecomeTutorPage.vue?vue&type=style&index=0&id=31125910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31125910"]])

export default __exports__